import styled from '@emotion/styled'

export const SignificanceWrapper = styled.div`
  display: flex;
  padding: 25px 0;
`
